(function ($) {
    $(document).ready(function () {
        var $form = $('#mc-embedded-subscribe-form');

        if ($form.length > 0) {
            $form.on('submit', function (e) {
                e.preventDefault();

                var $this = $(this);
                var $email = $('#mce-EMAIL');

                // Email validation
                if ($email.val().trim() === '' || $email.val().indexOf('@') === -1) {
                    $('#mce-error-response').html("Inserisci un indirizzo email valido.").show();
                    $('#mce-success-response').hide();
                    return;
                }

                // Privacy validation
                if (!$('#privacy-check').is(':checked')) {
                    $('#mce-error-response').html("Devi accettare la privacy policy per iscriverti.").show();
                    $('#mce-success-response').hide();
                    return;
                }

                var $submitButton = $this.find('button[type="submit"]');
                var originalButtonText = $submitButton.text();

                // Disable button and show loading state
                $submitButton.prop('disabled', true).text('Attendere...');

                // Prepare data for Mailchimp JSONP
                var data = $this.serialize();
                var action = $this.attr('action');

                // Ensure action is post-json and has &c=? for JSONP
                if (action.indexOf('post-json') === -1) {
                    action = action.replace('post?', 'post-json?');
                }
                if (action.indexOf('&c=?') === -1) {
                    action += '&c=?';
                }

                $.ajax({
                    type: "GET",
                    url: action,
                    data: data,
                    cache: false,
                    dataType: "jsonp",
                    jsonp: "c",
                    contentType: "application/json; charset=utf-8",
                    success: function (response) {
                        // Re-enable button
                        $submitButton.prop('disabled', false).text(originalButtonText);

                        if (response.result === 'success') {
                            // Hide form and show success message
                            $('#mc_embed_signup_scroll').hide();
                            $('#mce-success-response').html('Grazie per esserti iscritto alla nostra newsletter!').show();
                            $('#mce-error-response').hide();
                        } else {
                            // Show error message
                            var msg = response.msg;
                            if (response.msg.indexOf("already subscribed") >= 0) {
                                msg = "Sei già iscritto alla newsletter.";
                            }
                            $('#mce-error-response').html(msg).show();
                            $('#mce-success-response').hide();
                        }
                    },
                    error: function (err) {
                        // Re-enable button
                        $submitButton.prop('disabled', false).text(originalButtonText);
                        $('#mce-error-response').html("Si è verificato un errore. Riprova più tardi.").show();
                    }
                });
            });
        }
    });
})(jQuery);
